import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';
import { SuperAdminRentChargeDetailDto } from '@/features/superAdmin/features/data/types/superAdmin-data.types';
import {
    formatBoolean,
    formatDateTime,
    formatNavValue,
} from '@/features/superAdmin/features/data/shared/utils/superAdminDataFormatters';

type DetailField = {
    label: string;
    value: string;
};

type Props = {
    rentCharge: SuperAdminRentChargeDetailDto;
};

const SuperAdminRentChargeMainTab: FC<Props> = ({ rentCharge }) => {
    const { t } = useTranslation();

    const fields: DetailField[] = [
        { label: t('superAdmin.data.columns.id'), value: rentCharge.id },
        { label: t('superAdmin.data.columns.documentNumber'), value: rentCharge.documentNumber ?? '' },
        { label: t('superAdmin.data.columns.documentDate'), value: formatDateTime(rentCharge.documentDate) },
        { label: t('superAdmin.data.columns.tenant'), value: formatNavValue(rentCharge.tenantId, rentCharge.tenantName) },
        { label: t('superAdmin.data.columns.externalId'), value: rentCharge.externalId ?? '' },
        { label: t('superAdmin.data.columns.deletionMark'), value: formatBoolean(rentCharge.deletionMark) },
    ];

    return (
        <div className="rounded-semi-xl border border-popover-100 bg-popover-10 p-6">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                {fields.map((field) => (
                    <div key={field.label} className="flex flex-col gap-1.5">
                        <Label className="text-popover-800">{field.label}</Label>
                        <span className="break-all text-sm">{field.value || '—'}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SuperAdminRentChargeMainTab;
